export default "__VITE_ASSET__bdb9a925__"